export interface IUserInfo {
  EMAIL: string,
  FIRST_NAME: string,
  LAST_NAME: string,
  SESSION_ID: string
  TENANT_ID: string,
  USER_ID: string
};

export interface IRef {
  object: string,
  id: string
};

export interface IView {
  ref: IRef
};

export abstract class LayoutProviderService {
  abstract downloadLayout(userInfo: IUserInfo): Promise<any>;
  abstract getLayout(): Promise<any>;
  abstract setCurrentPerspective(perspectiveId: string): any;
  abstract getCurrentPerspective(): any;
  abstract lookupByRef(ref: IRef): any;
  abstract updateViewInLayout(view: IView): any;
}